import React from "react";
import { useState } from "react";
import FileBase from "react-file-base64";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { editProfile } from "../../actions/adminActions";

const Photo = ({ setPhoto }) => {
  const [preview, setPreview] = useState(null);
  const [targetFile, setTargetFile] = useState(null);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setPreview(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  const handleSaveEdit = async () => {
    const formData = new FormData();
    dispatch({
      type: "SET_CANVAS",
      payload: { openCanvas: true, message: "Setting profile..." },
    });
    const data = {
      profile: preview,
    };

    formData.append("thumbnail", targetFile);
    const { msg } = await editProfile(formData);

    dispatch({
      type: "SET_MESSAGE",
      payload: { canvasMessage: null, message: "Successfully changed profile" },
    });

    setPhoto(preview);
  };
  const setImage = (pictureFiles) => {
    setPhoto(pictureFiles);
    setPreview(pictureFiles[0].name);
  };
  return (
    <>
      <div className="photo_container">
        <div className="image_preview">
          <p className="detail_header">Image Preview</p>
          <img src={preview} alt={preview} />
        </div>
        <input
          type="file"
          multiple={false}
          onChange={(e) => {
            getBase64(e.target.files[0]);
            setTargetFile(e.target.files[0]);
          }}
          name="thumbnail"
          id="thumbnail"
        />
        {/* <ImageUploader
          singleImage={true}
          withIcon={true}
          buttonText="Choose images"
          onChange={setImage}
          imgExtension={[".jpg", ".gif", ".png", ".gif"]}
          maxFileSize={5242880}
        /> */}
        <button onClick={() => handleSaveEdit()}>Save</button>
      </div>
    </>
  );
};

export default Photo;
